export default __webpack_public_path__ + "static/media/logo-wayun-plus.9efbc45a.png";